/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { TurnBlock } from '@/components/chatGPT/TurnBlock';
import { watchHistoryChatBox } from '@/redux/slices/chatbox.slice';
import { useAppSelector } from '@/redux/hooks';

const HistoryChatBoxList = () => {
  const historyChatBox = useAppSelector(watchHistoryChatBox);

  return (
    <div css={listContainerStyles}>
      <div css={headerColumnsStyles}>
        <div>Thời gian</div>
        <div>Nội dung</div>
      </div>

      <div css={turnsListStyles}>
        {historyChatBox && historyChatBox.length === 0 ? (
          <div css={noDataStyles}>Không có dữ liệu phù hợp với bộ lọc.</div>
        ) : (
          (historyChatBox ?? []).map((turn, index) => (
            <ItemChatBox key={`${index} - ${turn.USER_ID}`} turn={turn} />
          ))
        )}
      </div>
    </div>
  );
};

const ItemChatBox = ({ turn }: { turn: ChatTurn }) => {
  return <TurnBlock turn={turn} />;
};

const listContainerStyles = css`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const headerColumnsStyles = css`
  display: grid;
  grid-template-columns: 22rem 20rem 1fr;
  align-items: center;
  gap: 1.2rem;
  padding: 1rem 0.4rem 0.8rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #6b7280;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 1.2rem;
`;

const turnsListStyles = css`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding-bottom: 1.6rem;
`;

const noDataStyles = css`
  border-radius: 1.6rem;
  border: 1px solid #e5e7eb;
  background: white;
  padding: 2.4rem;
  text-align: center;
  font-size: 1.4rem;
  color: #6b7280;
`;

export default HistoryChatBoxList;
